var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3.75H4.5C4.08579 3.75 3.75 4.08579 3.75 4.5V6C3.75 6.41421 4.08579 6.75 4.5 6.75H6C6.41421 6.75 6.75 6.41421 6.75 6V4.5C6.75 4.08579 6.41421 3.75 6 3.75ZM4.5 2.25C3.25736 2.25 2.25 3.25736 2.25 4.5V6C2.25 7.24264 3.25736 8.25 4.5 8.25H6C7.24264 8.25 8.25 7.24264 8.25 6V4.5C8.25 3.25736 7.24264 2.25 6 2.25H4.5Z",
    fill: "#1A1D1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 11.25H4.5C4.08579 11.25 3.75 11.5858 3.75 12V13.5C3.75 13.9142 4.08579 14.25 4.5 14.25H6C6.41421 14.25 6.75 13.9142 6.75 13.5V12C6.75 11.5858 6.41421 11.25 6 11.25ZM4.5 9.75C3.25736 9.75 2.25 10.7574 2.25 12V13.5C2.25 14.7426 3.25736 15.75 4.5 15.75H6C7.24264 15.75 8.25 14.7426 8.25 13.5V12C8.25 10.7574 7.24264 9.75 6 9.75H4.5Z",
    fill: "#1A1D1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 3.75H12C11.5858 3.75 11.25 4.08579 11.25 4.5V6C11.25 6.41421 11.5858 6.75 12 6.75H13.5C13.9142 6.75 14.25 6.41421 14.25 6V4.5C14.25 4.08579 13.9142 3.75 13.5 3.75ZM12 2.25C10.7574 2.25 9.75 3.25736 9.75 4.5V6C9.75 7.24264 10.7574 8.25 12 8.25H13.5C14.7426 8.25 15.75 7.24264 15.75 6V4.5C15.75 3.25736 14.7426 2.25 13.5 2.25H12Z",
    fill: "#1A1D1F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 11.25H12C11.5858 11.25 11.25 11.5858 11.25 12V13.5C11.25 13.9142 11.5858 14.25 12 14.25H13.5C13.9142 14.25 14.25 13.9142 14.25 13.5V12C14.25 11.5858 13.9142 11.25 13.5 11.25ZM12 9.75C10.7574 9.75 9.75 10.7574 9.75 12V13.5C9.75 14.7426 10.7574 15.75 12 15.75H13.5C14.7426 15.75 15.75 14.7426 15.75 13.5V12C15.75 10.7574 14.7426 9.75 13.5 9.75H12Z",
    fill: "#1A1D1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.b149cf7a0963f56bffd9e6519077b4a2.svg";
export { ForwardRef as ReactComponent };